module.exports = __webpack_public_path__ + "img/step-8.fdad809e.jpg";